import { render, staticRenderFns } from "./AlertSetting.vue?vue&type=template&id=5242e89e&scoped=true&"
import script from "./AlertSetting.vue?vue&type=script&lang=js&"
export * from "./AlertSetting.vue?vue&type=script&lang=js&"
import style0 from "./AlertSetting.vue?vue&type=style&index=0&id=5242e89e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5242e89e",
  null
  
)

component.options.__file = "AlertSetting.vue"
export default component.exports